import { forwardRef } from 'react'

import s from './Input.module.scss'

import { ControlLabel } from 'components/UI/ControlLabel/ControlLabel'
import { ControlsError } from 'components/UI/ControlsError/ControlsError'

export interface InputProps
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  icon?: React.ReactNode
  error?: string | boolean
  label?: React.ReactNode
  labelClassName?: string
  wrapperClassName?: string
  inputClassName?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function (
  { icon, error, label, labelClassName, wrapperClassName, inputClassName, ...inputProps },
  ref
) {
  return (
    <div className={`${s.inCustom} ${wrapperClassName}`}>
      {!!label && <ControlLabel labelContent={label} className={labelClassName} htmlFor={inputProps?.name} />}
      <div className={`${s.inWrapper} ${!!error ? s.errorBorder : ''}`}>
        {icon && <div className={`${s.iconWrapper} ${!!error ? s.errorIcon : ''}`}>{icon}</div>}
        <input {...inputProps} className={inputClassName} ref={ref} />
      </div>
      {typeof error === 'string' && error ? <ControlsError error={error} /> : null}
    </div>
  )
})
